import { ReactNode, isValidElement } from "react";

/**
 * Checks if the given ReactNode contains a noindex meta tag
 */
export function containsNoIndexMeta(additionalHeadTags: ReactNode): boolean {
  if (!additionalHeadTags) return false;

  // Check if additionalHeadTags is a string containing "noindex"
  if (
    typeof additionalHeadTags === "string" &&
    additionalHeadTags.includes("noindex")
  ) {
    return true;
  }

  // If it's a ReactNode or array of ReactNodes, try to check props
  if (isValidElement(additionalHeadTags)) {
    const props = additionalHeadTags.props as {
      content?: string;
      children?: ReactNode;
      name?: string;
    };

    if (props.content?.includes("noindex")) {
      return true;
    }

    // If it has children, recursively check them
    if (props.children) {
      const children = Array.isArray(props.children)
        ? props.children
        : [props.children];

      return children.some(
        (child) =>
          isValidElement(child) &&
          (child.props as { name?: string; content?: string })?.name ===
            "robots" &&
          (
            child.props as { name?: string; content?: string }
          )?.content?.includes("noindex"),
      );
    }
  }

  return false;
}
